module.exports = __webpack_public_path__ + "img/money.d342f34b.png";